/**
 * Plano professor "Educador Digital": painel dedicado em `/dashboard-educador-digital`.
 */
export function isEducadorDigitalPlan(user) {
    if (!user || typeof user !== 'object') return false;
    const plan = user.active_subscription?.plan;
    if (!plan) return false;
    return String(plan.name || '').toLowerCase().includes('educador digital');
}

/**
 * @deprecated Preferir `resolvePathWhenRedirectIsRoot` de `@/utils/teacherHomePath`
 * (considera preferência do novo dashboard). Mantido para compatibilidade.
 */
export function resolvePathWhenRedirectIsRoot(redirectPath, user) {
    const raw = typeof redirectPath === 'string' && redirectPath.trim() ? redirectPath.trim() : '/';
    let pathOnly = raw;
    const q = raw.indexOf('?');
    if (q !== -1) pathOnly = raw.slice(0, q);
    if (pathOnly === '/' || pathOnly === '') {
        if (isEducadorDigitalPlan(user)) {
            return '/dashboard-educador-digital';
        }
    }
    return raw;
}
